import Screen from './screen';
import template from './templates/aoe.html';
import { resizeContentHeight, getContentHeight } from "../../utils/resizeContentHeight";
import { LoadingElement } from './loadingElement';
import { TrackingNotice } from '../../customNotice/botNotice/trackingNotice';
export class AOEScreen extends Screen {
    constructor(uic) {
        super("aoe", uic);
        this.resizeHeight = () => {
            resizeContentHeight(this.elements['widgetWindow'], this.elements['aoe']);
            let chatWindowHeight = $('.cbot-chatWindow').height();
            let nonContentHeight = getContentHeight(this.elements['widgetWindow']);
            let contentHeight = 0;
            this.elements['aoe'].find('.content *').each((index, element) => {
                let jqe = $(element);
                if (jqe.is(':visible')) {
                    contentHeight += jqe.outerHeight();
                    contentHeight += parseInt(jqe.css("margin-top")) > 0 ? parseInt(jqe.css("margin-top")) : 0;
                    contentHeight += parseInt(jqe.css("margin-bottom")) > 0 ? parseInt(jqe.css("margin-bottom")) : 0;
                }
            });
            let space = chatWindowHeight - nonContentHeight - contentHeight;
            if (space < 0) {
                space = 0;
            }
            space /= 2;
            $('#cbot-feedback-aoe-space-top').css('height', space + "px");
            $('#cbot-feedback-aoe-space-bottom').css('height', space + "px");
        };
        this.elements = {};
    }
    show(options) {
        this.elements['aoe'].show();
        this.stopLoadingAnimation();
        this.uic.widgetHeaderController.enableEndChatOnCloseButton();
        this.resizeHeight();
    }
    hide() {
        this.elements.aoe.hide();
    }
    bootstrapScreen(chatWindowElement) {
        chatWindowElement.append(template);
        this.elements['widgetWindow'] = $('#chatbotWindow');
        this.elements['aoe'] = $('#cbot-feedback-aoe');
        this.elements['aoeNewQuestionButton'] = $('#cbot-feedback-aoe__button1');
        this.elements['aoeQuitButton'] = $('#cbot-feedback-aoe__button2');
        this.elements['aoeFooter'] = $('#cbot-feedback-aoe').find('.cbot-feedback__footer');
        this.elements['aoeNewQuestionButton'].click(() => {
            this.loadingAnimation();
            let trackingNotice = new TrackingNotice("chat", "AOE_screen_new_question", "AOE_screen_new_question");
            this.uic.widget.sendCustomNotice(trackingNotice).then(() => {
                this.uic.widget.silentlyRestartChatSession();
            });
        });
        this.elements['aoeQuitButton'].click(() => {
            this.uic.widget.track("chat", "chat_ended", "closed");
            let trackingNotice = new TrackingNotice("chat", "Chat_end_closed", "Chat_end_closed");
            this.uic.widget.endChatSession(this.uic.widget.sendCustomNotice(trackingNotice));
        });
        // -----------------------------------------------------------------------------
        //                         DYNAMICALLY RESIZE CONTENT
        // -----------------------------------------------------------------------------
        $('.cbot-chatbotWindow').onload = this.resizeHeight();
        this.elements['loader'] = new LoadingElement(this.elements['aoeFooter'], "aoe");
    }
    resizeEvent() {
        this.resizeHeight();
        // Fix for Firefox to scroll to focused input
        if ($(':focus').get(0)) {
            $(':focus').get(0).scrollIntoView();
        }
    }
    stopLoadingAnimation() {
        this.elements['loader'].hide();
        this.elements['aoeQuitButton'].show();
        this.elements['aoeNewQuestionButton'].show();
    }
    loadingAnimation() {
        this.elements['loader'].show();
        this.elements['aoeQuitButton'].hide();
        this.elements['aoeNewQuestionButton'].hide();
    }
}
